//import React, { useState, useEffect } from 'react';
import HeaderTitle from '../../../components/typography/header-title';
//import Home from '../../components/securityComponent/home';
export default function ToolManagement() {
    return (
        <>
            <HeaderTitle
                title={'Tool Management'}
                subtitle={
                    'Manage tools'
                }
            />
            <div>Coming Soon</div>
        </>
    );
}
